<app-progress-indicator *ngIf="isLoading" [transparency]="0.5"></app-progress-indicator>
<mat-card class="card-content">
  <mat-card-content class="content-wdh">
    <mat-card-title>
      <div>
        <h4 *ngIf="!editGroupName" class="truncated">
          {{ propertyGroup.name }}
        </h4>
        <div *ngIf="editGroupName">
          <input
            class="edit-input-field"
            [(ngModel)]="propertyGroup.newName"
            type="text"
            name="newGroupName"
            required
            (click)="$event.stopPropagation()"
          />
        </div>
      </div>
    </mat-card-title>
    <span> {{ propertyGroup.createdDate | simpleDate }} </span>
    <mat-card-footer>
      <div class="mat-icon-button"><mat-icon>home</mat-icon></div>
      <div class="property-value">{{ propertyGroup.favCount }}</div>
    </mat-card-footer>
  </mat-card-content>
  <div *ngIf="!editGroupName" class="menu-wdh">
    <button
      class="mat-icon-button"
      [matMenuTriggerFor]="favGroupMenu"
      #favMenuTrigger="matMenuTrigger"
      (click)="$event.stopPropagation()"
    >
      <mat-icon class="vert-menu">more_vert</mat-icon>
    </button>

    <mat-menu
      #favGroupMenu="matMenu"
      class="mt-0 actionWrap"
      id="fldproplist_action"
      yPosition="below"
      xPosition="before"
    >
      <button (click)="enableEditing(propertyGroup.id)" mat-menu-item aria-label="edit" class="edit">
        <mat-icon>edit</mat-icon><span>Edit name</span>
      </button>
      <button
        [disabled]="propertyGroup.mode === 'Default'"
        mat-menu-item
        aria-label="delete"
        class="delete"
        (click)="propertyGroup.mode !== 'Default' ? deleteGroup(propertyGroup.id, propertyGroup.favCount) : ''"
      >
        <mat-icon>delete</mat-icon><span>{{ stringRes.DELETE_WATCH_LIST }}</span>
      </button>
      <button
        mat-menu-item
        class="export"
        (click)="readyToExport('group', propertyGroup.id, propertyGroup.name)"
        [disabled]="!propertyGroup.favCount"
      >
        <mat-icon>get_app</mat-icon><span>Export CSV</span>
      </button>
      <button
        mat-menu-item
        class="export"
        *ngIf="isExternalExportEnabled"
        (click)="externalExport(propertyGroup)"
        [disabled]="!propertyGroup.favCount"
      >
        <mat-icon> publish </mat-icon>
        <span>Export to {{ companyName }}</span>
      </button>
    </mat-menu>
    <mat-spinner
      [diameter]="30"
      class="spinner_size mt-2 mr-3"
      *ngIf="exportingInProgress && exportingInProgress['group' + propertyGroup.id]"
    ></mat-spinner>
  </div>
  <div *ngIf="editGroupName" (click)="$event.stopPropagation()">
    <div style="display: flex">
      <button mat-icon-button aria-label="close" matTooltip="Close">
        <i
          class="material-icons"
          style="font-size: 20px; color: #60697a"
          (click)="cancelEditing(); $event.stopPropagation()"
        >
          cancel
        </i>
      </button>
      <button mat-icon-button aria-label="Ok" matTooltip="Ok">
        <i
          class="material-icons"
          style="font-size: 20px; color: #4caf50; transform: rotate(0deg)"
          (click)="updateGroupName(propertyGroup, i); $event.stopPropagation()"
        >
          done
        </i>
      </button>
    </div>

    <div *ngIf="isGroupNameChangeInProgress && isGroupNameChangeInProgress[i]">
      <mat-spinner [diameter]="30" class="spinner_size mr-3"></mat-spinner>
    </div>
  </div>
</mat-card>
